const RoomTeamBackgroundAndColors = [
  { id: 1, backgroundColor: "#ADD8E6", textColor: "#00008B" },
  { id: 2, backgroundColor: "#98FB98", textColor: "#006400" },
  { id: 3, backgroundColor: "#FFFFE0", textColor: "#B8860B" },
  { id: 4, backgroundColor: "#E6E6FA", textColor: "#9400D3" },
  { id: 5, backgroundColor: "#FFA07A", textColor: "#8B0000" },
  { id: 6, backgroundColor: "#D3D3D3", textColor: "#2F4F4F" },
  { id: 7, backgroundColor: "#FFB6C1", textColor: "#FF69B4" },
];

export default RoomTeamBackgroundAndColors;
